import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface EditDeclarantLogoProps {
  declarantId: string;
  file: File;
}

export const useEditDeclarantLogo = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: EditDeclarantLogoProps) => {
      const formData = new FormData();
      formData.append('file', payload.file);
      formData.append('declarantId', payload.declarantId);
      await request({
        path: `declarant/update-logo`,
        method: 'POST',
        authenticate: true,
        dataObject: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-declarants'] });
      toast.success('Declarant logo uploaded successfully!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error uploading declarant logo!');
    },
  });
};
